'use strict';

import React from 'react';
import { connect } from 'react-redux';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { appSelectors, appOperations } from '@/state/domains/app';
import { locationsSelectors } from '@/state/domains/locations';

import Link from '@/views/common/Link';

import s from '@/views/common/Link/styles.scss';

export default connect(
	(state, props) => ({
		pageId: appSelectors.getPageId(state, props),
		location: appSelectors.getLocation(state, props),
	}),
	{
	}
)(
	({ username, date, location }) => {

		let dateMode = true;

		if (location.state) {
			dateMode = !location.state.dateMode;
		}

		const dateStr = format(new Date(date + ' 00:00:00'), 'MMM do');

		return (
			<Link to={{
					pathname: location.pathname,
					state: { ...location.state, dateMode },
				}}
				className={ s.noLinkStyle }
			>
				{ dateMode && <FontAwesomeIcon icon='calendar-days' color='#444'/> }
				{ !dateMode && dateStr }
			</Link>
		);
	}
);
